import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { useTranslation } from 'react-i18next';

import { filterIcons } from '../icons';
import { Checkbox, Tooltip } from '../../../../../../BaseComponents';
import { FormControlLabel } from '@mui/material';
import { useIsTabletMiddle } from '../../../../../../utils';

interface Props {
	title: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	checked: boolean;
	disabled: boolean;
}

const FilterCheckbox: React.FC<Props> = ({ className, onChange, title, checked, disabled }) => {
	const theme = useTheme('SeatMap').PassengerFilters;
	const { t } = useTranslation('SeatMap');

	const isTabletMiddle = useIsTabletMiddle();

	const filterIcon = React.useMemo(() => {
		return filterIcons[title] ?? null;
	}, [title]);

	return (
		<Tooltip
			title={t('The filter does not affect the number of available seats at the current settings')}
			disableHoverListener={!disabled}
			disableTouchListener={!disabled}
			enterTouchDelay={0}
			leaveTouchDelay={1500}
			placement={isTabletMiddle ? 'top' : 'right'}
		>
			<div
				className={cn(theme.filter, className, {
					[theme.filter_checked]: checked,
					[theme.filter_disabled]: disabled
				})}
			>
				<FormControlLabel
					labelPlacement="start"
					classes={{ root: theme.filter__label }}
					disabled={disabled}
					control={
						<Checkbox
							classes={{
								root: theme.checkbox,
								checked: theme.checkbox_checked
							}}
							value={title}
							checked={checked}
							onChange={onChange}
						/>
					}
					label={
						<>
							{filterIcon && <span className={theme.icon}>{filterIcon}</span>} {t(`Restriction_${title}`)}
						</>
					}
				/>
			</div>
		</Tooltip>
	);
};

export default FilterCheckbox;
